import { render, staticRenderFns } from "./BidsAddBulkColumnChooserColumn.vue?vue&type=template&id=91735308"
import script from "./BidsAddBulkColumnChooserColumn.vue?vue&type=script&lang=js"
export * from "./BidsAddBulkColumnChooserColumn.vue?vue&type=script&lang=js"
import style0 from "./BidsAddBulkColumnChooserColumn.vue?vue&type=style&index=0&id=91735308&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports